@let $border = border();

<div
  class="mbs-card"
  [ngClass]="cardMainClasses()"
  [class.-no-border]="!$border"
  [class.-no-padding]="!hasPadding()"
  [class.border-danger]="$border && invalid()"
  [class.inner-bordered]="innerBordered()"
  [class.overflow-y-auto]="!!staticHeight()">
  <div class="mbs-card_content">
    <ng-content select="mbs-card-header" />
    <div class="mbs-card_body">
      @if (cardGroups()) {
        <div class="mbs-card_groups">
          <ng-content select="mbs-card-group" />
        </div>
      }
      <ng-content />
    </div>
  </div>

  <ng-content select="mbs-card-footer" />
</div>
